export const ORTHODONTIC_SPECIALITYID = 150;
